/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LocationItemDTO } from './LocationItemDTO';
import {
    LocationItemDTOFromJSON,
    LocationItemDTOFromJSONTyped,
    LocationItemDTOToJSON,
} from './LocationItemDTO';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';

/**
 * 
 * @export
 * @interface LocationItemDTOPage
 */
export interface LocationItemDTOPage {
    /**
     * 
     * @type {Array<LocationItemDTO>}
     * @memberof LocationItemDTOPage
     */
    content?: Array<LocationItemDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof LocationItemDTOPage
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LocationItemDTOPage
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LocationItemDTOPage
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof LocationItemDTOPage
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof LocationItemDTOPage
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof LocationItemDTOPage
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof LocationItemDTOPage
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof LocationItemDTOPage
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof LocationItemDTOPage
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the LocationItemDTOPage interface.
 */
export function instanceOfLocationItemDTOPage(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LocationItemDTOPageFromJSON(json: any): LocationItemDTOPage {
    return LocationItemDTOPageFromJSONTyped(json, false);
}

export function LocationItemDTOPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationItemDTOPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(LocationItemDTOFromJSON)),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function LocationItemDTOPageToJSON(value?: LocationItemDTOPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(LocationItemDTOToJSON)),
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

